import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=492b5ef3&scoped=true"
import script from "./cookie-consent.vue?vue&type=script&lang=js"
export * from "./cookie-consent.vue?vue&type=script&lang=js"
import style0 from "./cookie-consent.vue?vue&type=style&index=0&id=492b5ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b5ef3",
  null
  
)

export default component.exports